import { memo } from 'react';
import { useEditMode } from '../../focus/useIsEditMode';
import { EditableQuestion } from '../EditableQuestion';
import { useQuizControl } from '../QuizControlProvider';
import { AddAnswerButton } from './AddAnswerButton';
import { MAX_ANSWER_COUNT } from './const';
import { EditableSubjectiveAnswer } from './EditableSubjectiveAnswer';
import { useSubjectiveAnswers } from './useSubjectiveAnswers';
export const EditableSubjective = memo(() => {
  const {
    control,
    index
  } = useQuizControl();
  const {
    answers,
    handleRemove,
    handleAdd
  } = useSubjectiveAnswers({
    control,
    index
  });
  const {
    onEditModeChange,
    isEditMode
  } = useEditMode();
  return <div className="flex flex-col gap-xs pb-xs" onClick={e => e.stopPropagation()}>
      <EditableQuestion />

      <div className="relative flex flex-col gap-2xs">
        {answers.map((answer, answerIndex) => {
        return <EditableSubjectiveAnswer key={answer.key} onFocus={() => {
          onEditModeChange(true);
        }} onRemove={answers.length > 1 && isEditMode ? () => handleRemove(answerIndex) : undefined} answerIndex={answerIndex} answerKey={answer.key} isLastAnswer={answerIndex === answers.length - 1} />;
      })}
      </div>
      {answers.length < MAX_ANSWER_COUNT && isEditMode && <AddAnswerButton onClick={handleAdd} />}
    </div>;
});